import React from 'react';
import styled from '@emotion/styled';

import { minTablet, minDesktop, mediaPhone } from '../styles/breakpoints';

import Introduction from './Introduction';
import DownloadMaterial from './DownloadMaterial';
import MaterialDescription from './MaterialDescription';

const DownloadMaterialWithDescription = styled.div`
  display: flex;
  flex-direction: column;

  ${minTablet} {
    flex-direction: row;
    justify-content: space-around;
  }

  ${minDesktop} {
    display: block;
  }
`;

const DownloadMaterialStyled = styled(DownloadMaterial)`
  flex: 0 1 auto;

  ${mediaPhone} {
    margin-bottom: 40px;
    max-width: 270px; 
  }

  ${minTablet} {
    flex: 0 1 306px;
    margin-left: 0;
    margin-right: 0;
  }

  ${minDesktop} {
    margin-bottom: 50px;
  }
`;

const MaterialDescriptionStyled = styled(MaterialDescription)`
  max-width: 340px;

  ${mediaPhone} {
    margin-left: auto;
    margin-right: auto;
  }

  flex: 0 1 auto;

  ${minTablet} {
    flex: 0 1 300px;
  }
`;

const Section = styled.section`
  ${minDesktop} {
    display: flex;
    justify-content: space-between;
    max-width: 1020px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const IntroductionStyled = styled(Introduction)`
  ${minDesktop} {
    flex: 0 1 600px;
    padding-bottom: 150px;
  }
`;

const AboutMaterialDownload = () => (
  <Section>
    <IntroductionStyled />
    <DownloadMaterialWithDescription>
      <DownloadMaterialStyled />
      <MaterialDescriptionStyled />
    </DownloadMaterialWithDescription>
  </Section>
);

export default AboutMaterialDownload;



// WEBPACK FOOTER //
// ./src/components/AboutMaterialDownload/AboutMaterialDownload.js